import { retryImport } from 'import'
import type Compressor from 'compressorjs'

export async function importCompressor(): Promise<typeof Compressor> {
  return retryImport(() => import('compressorjs'), 'compressorjs').then(
    ({ default: Compressor }) => Compressor
  )
}
